export class UtilFunctions {
  static replaceOrAddObjectInTheList(element: any, elements: any[]): void {
    const indexToReplace = elements.findIndex((e: any) => e.id === element?.id);

    if (indexToReplace !== -1) {
      elements[indexToReplace] = element;
    } else {
      elements.unshift(element);
    }
  }
  static deleteWithIdInTheList(element: any, elements: any[]): void {
    const elementIndex = elements.findIndex((el) => el.id === element.id);

    if (elementIndex !== -1) {
      elements.splice(elementIndex, 1);
    }
  }
}
